import { ITheme } from '../types';

const theme: ITheme = {
  name: 'automate',
  colors: {
    body: 'white',
    header: 'white',
    text: '#595959',
    textAccent: '#e0e5ff',
    accent: '#2f4ffd',
    accentGradient: '#2f4ffd',
    shadow: '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)',
    border: '#d9d9d9',
    weak: '#fafafa',
    disabled: '#e9e9e9',
    disabledText: '#bfbfbf',
  },
  assets: {
    logoMain: '/assets/themes/automate__logo_main.svg',
  },
};

export default theme;
